/* ── Admin Video Manager (ES Module) ── */
import { 
  catalog, selectedChannel, editingVideoIndex, originalVideoSnapshot, 
  returnToSearch, updateState, currentUser
} from '../admin-globals.js';
import { normalizeYoutubeVideoId } from '../admin-yt.js';
import { showToast, showConfirm, escHtml } from '../admin-ui-base.js';
import { authHeaders } from '../admin-auth.js';
import { renderVideoList, renderSidebar } from '../catalog-ui.js';

/**
 * Abre el modal para añadir un nuevo vídeo
 */
export function openAddVideo() {
  updateState('editingVideoIndex', null);
  document.getElementById('modal-title').textContent = 'AÑADIR VÍDEO';
  document.getElementById('vid-type').value = 'youtube';
  document.getElementById('vid-yt-id').value = '';
  document.getElementById('vid-minio-url').value = '';
  document.getElementById('vid-title').value = '';
  document.getElementById('vid-duration').value = '';
  document.getElementById('vid-trim-start').value = '';
  document.getElementById('vid-trim-end').value = '';
  onTypeChange();
  document.getElementById('video-modal').classList.remove('hidden');
}

/**
 * Abre el modal para editar un vídeo existente
 */
export function openEditVideo(index) {
  const vid = catalog[selectedChannel].videos[index];
  updateState('editingVideoIndex', index);
  updateState('originalVideoSnapshot', JSON.stringify(vid));
  
  document.getElementById('modal-title').textContent = 'EDITAR VÍDEO';
  document.getElementById('vid-type').value = vid.type;
  document.getElementById('vid-yt-id').value = vid.id || '';
  document.getElementById('vid-minio-url').value = vid.url || '';
  document.getElementById('vid-title').value = vid.title || '';
  document.getElementById('vid-duration').value = vid.duration || '';
  document.getElementById('vid-yt-duration').value = vid.duration || '';
  document.getElementById('vid-trim-start').value = vid.trim_start || '';
  document.getElementById('vid-trim-end').value = vid.trim_end || '';
  
  const ytStatus = document.getElementById('yt-duration-status');
  const minioStatus = document.getElementById('minio-duration-status');
  
  if(vid.duration) {
    const txt = `DURACIÓN: ${Math.floor(vid.duration/60)}m ${Math.round(vid.duration%60)}s (${vid.duration}s)`;
    ytStatus.textContent = txt;
    ytStatus.style.color = 'rgba(0,255,136,0.7)';
    minioStatus.textContent = txt;
    minioStatus.style.color = 'rgba(0,255,136,0.7)';
  } else {
    ytStatus.textContent = '';
    minioStatus.textContent = '';
  }
  onTypeChange();
  document.getElementById('video-modal').classList.remove('hidden');
}

export function closeVideoModal() {
  document.getElementById('video-modal').classList.add('hidden');
  if (returnToSearch) {
    updateState('returnToSearch', false);
    document.getElementById('search-modal').classList.remove('hidden');
  }
}

export function onTypeChange() {
  const type = document.getElementById('vid-type').value;
  const isYT = type === 'youtube';
  document.getElementById('field-yt-id').classList.toggle('hidden', !isYT);
  document.getElementById('field-minio-url').classList.toggle('hidden', isYT);
  document.getElementById('field-duration').classList.add('hidden');
}

export function saveVideo() {
  const _backToSearch = returnToSearch;
  const type = document.getElementById('vid-type').value;
  const title = document.getElementById('vid-title').value.trim();

  if (!title) { showToast('FALTA EL TÍTULO', true); return; }

  let vid = { type, title };

  if (type === 'youtube') {
    const raw = document.getElementById('vid-yt-id').value.trim();
    if (!raw) { showToast('FALTA EL ID DE YOUTUBE', true); return; }
    const id = normalizeYoutubeVideoId(raw);
    if (!id) {
      showToast('URL O ID DE YOUTUBE NO VÁLIDOS', true);
      return;
    }
    vid.id = id;
    const ytDur = parseFloat(document.getElementById('vid-yt-duration').value);
    if (!isNaN(ytDur) && ytDur > 0) vid.duration = Math.round(ytDur);
  } else {
    const url = document.getElementById('vid-minio-url').value.trim();
    if (!url) { showToast('FALTA LA URL', true); return; }
    vid.url = url;
    const dur = parseFloat(document.getElementById('vid-duration').value);
    if (!isNaN(dur) && dur > 0) vid.duration = dur;
  }

  const trimStart = parseInt(document.getElementById('vid-trim-start').value);
  const trimEnd = parseInt(document.getElementById('vid-trim-end').value);
  if (!isNaN(trimStart) && trimStart > 0) vid.trim_start = trimStart;
  if (!isNaN(trimEnd) && trimEnd > 0) vid.trim_end = trimEnd;

  const videos = catalog[selectedChannel].videos;
  if (editingVideoIndex !== null) {
    if (originalVideoSnapshot && JSON.stringify(vid) === originalVideoSnapshot) {
      closeVideoModal();
      return;
    }
    videos[editingVideoIndex] = vid;
    showToast('VÍDEO ACTUALIZADO');
  } else {
    videos.push(vid);
    showToast('VÍDEO AÑADIDO');
    closeVideoModal();
    renderVideoList();
    if (_backToSearch) document.getElementById('search-modal').classList.remove('hidden');
    if (window.saveCatalog) window.saveCatalog();
    return;
  }

  closeVideoModal();
  renderVideoList();
  if (_backToSearch) document.getElementById('search-modal').classList.remove('hidden');
  if (window.saveCatalog) window.saveCatalog();
}

export function shuffleVideos() {
  const videos = catalog[selectedChannel].videos;
  if (videos.length < 2) return;
  for (let i = videos.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [videos[i], videos[j]] = [videos[j], videos[i]];
  }
  renderVideoList();
  showToast('ORDEN ALEATORIO — GUARDA PARA SINCRONIZAR');
}

export function deleteVideo(index) {
  catalog[selectedChannel].videos.splice(index, 1);
  renderVideoList();
  showToast('VÍDEO ELIMINADO');
  if (window.saveCatalog) window.saveCatalog();
}

export function clearVideos() {
  const ch = catalog[selectedChannel];
  showConfirm(
    `Se eliminarán todos los vídeos de "${ch.name}". Esta acción no se puede deshacer.`,
    () => { ch.videos = []; renderVideoList(); showToast('CANAL VACIADO'); if (window.saveCatalog) window.saveCatalog(); },
    '¿VACIAR CANAL?'
  );
}

export function moveVideo(index, dir) {
  const videos = catalog[selectedChannel].videos;
  const newIndex = index + dir;
  if (newIndex < 0 || newIndex >= videos.length) return;
  [videos[index], videos[newIndex]] = [videos[newIndex], videos[index]];
  renderVideoList();
  if (window.saveCatalog) window.saveCatalog();
}

export function toggleFlag(index) {
  const vid = catalog[selectedChannel].videos[index];
  vid.flagged = !vid.flagged;
  renderVideoList();
  if (window.saveCatalog) window.saveCatalog();
}

/**
 * Busca o crea el canal de cuarentena colaborativo
 */
async function getOrCreateQuarantineChannel() {
  let qIndex = catalog.findIndex(ch => ch.name === '[⚠️] CUARENTENA');
  if (qIndex !== -1) return qIndex;

  showToast('CREANDO CANAL DE CUARENTENA...');
  try {
    const res = await fetch('/channels', {
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: JSON.stringify({
        num: "99",
        name: '[⚠️] CUARENTENA',
        color: '#ff9500',
        sync: false
      })
    });
    if (!res.ok) throw new Error(await res.text());
    const newCh = await res.json();
    catalog.push(newCh);
    renderSidebar();
    return catalog.length - 1;
  } catch (e) {
    console.error(e);
    showToast('ERROR AL CREAR CUARENTENA', true);
    return -1;
  }
}

/**
 * Mueve un vídeo al canal de cuarentena oficial
 */
export async function moveToQuarantine(index) {
  const currentCh = catalog[selectedChannel];
  const qIndex = await getOrCreateQuarantineChannel();
  if (qIndex === -1) return;

  const quarantineCh = catalog[qIndex];
  if (currentCh.id === quarantineCh.id) {
    showToast('YA ESTÁ EN CUARENTENA', true);
    return;
  }

  const [vid] = currentCh.videos.splice(index, 1);
  vid.flagged = true;
  vid.origin_ch_num = currentCh.num;
  quarantineCh.videos.push(vid);

  // Sincronización doble
  if (window.saveCatalog) await window.saveCatalog(); 
  
  const originSelected = selectedChannel;
  window.selectChannel(qIndex);
  if (window.saveCatalog) await window.saveCatalog();
  window.selectChannel(originSelected);

  renderVideoList();
  showToast('MOVIDO A CUARENTENA (COLABORATIVO)');
}

/**
 * Restaura un vídeo de la cuarentena a su canal original o elegido
 */
export async function restoreFromQuarantine(index) {
  const quarantineCh = catalog[selectedChannel];
  const vid = quarantineCh.videos[index];
  let targetIndex = -1;

  if (vid.origin_ch_num !== undefined) {
    const originIdx = catalog.findIndex(ch => ch.num == vid.origin_ch_num);
    if (originIdx !== -1 && catalog[originIdx].id !== quarantineCh.id) {
      const confirmRestore = confirm(`¿RESTAURAR A "${catalog[originIdx].name}" (CH ${vid.origin_ch_num})?`);
      if (confirmRestore) targetIndex = originIdx;
    }
  }

  if (targetIndex === -1) {
    const availableChannels = catalog
      .map((ch, i) => ({ name: ch.name, index: i, id: ch.id, num: ch.num }))
      .filter(ch => ch.id !== quarantineCh.id);

    if (availableChannels.length === 0) {
      showToast('NO HAY CANALES DISPONIBLES', true);
      return;
    }

    const options = availableChannels.map(ch => `${ch.index}: CH ${ch.num} - ${ch.name}`).join('\n');
    const targetStr = prompt(`¿A QUÉ CANAL RESTAURAR?\n\n${options}\n\nIntroduce el ÍNDICE:`);
    targetIndex = parseInt(targetStr);
    
    if (isNaN(targetIndex) || !catalog[targetIndex] || catalog[targetIndex].id === quarantineCh.id) {
      if (targetStr !== null) showToast('ÍNDICE NO VÁLIDO', true);
      return;
    }
  }

  const prevChannelIdx = selectedChannel;
  const [removedVid] = quarantineCh.videos.splice(index, 1);
  removedVid.flagged = false;
  delete removedVid.origin_ch_num;
  catalog[targetIndex].videos.push(removedVid);

  if (window.saveCatalog) await window.saveCatalog();
  window.selectChannel(targetIndex);
  if (window.saveCatalog) await window.saveCatalog();
  
  window.selectChannel(prevChannelIdx);
  renderVideoList();
  showToast('VÍDEO RESTAURADO');
}

// ── Mover vídeo entre canales (misma API que inbox TV; solo admins) ───────────
const MOVE_UI_KEY = 'raptv_admin_move_to_channel';

function isTopVotedChannel(ch) {
  return !!(ch && (ch.top_voted || ch.is_top_voted));
}

export function setMoveChannelUi(enabled) {
  localStorage.setItem(MOVE_UI_KEY, enabled ? '1' : '0');
  renderVideoList();
}

let _moveVideoIndex = null;

export function openMoveVideoToChannel(index) {
  if (!currentUser?.is_admin) {
    showToast('Solo administradores pueden mover entre canales', true);
    return;
  }
  const fromCh = catalog[selectedChannel];
  if (!fromCh?.id) return;
  if (isTopVotedChannel(fromCh)) {
    showToast('Canal “Top voted”: la lista es dinámica, no se puede mover desde aquí', true);
    return;
  }

  _moveVideoIndex = index;
  const modal = document.getElementById('move-video-channel-modal');
  const list = document.getElementById('move-video-channel-list');
  const hint = document.getElementById('move-video-channel-hint');
  if (!modal || !list) return;

  const vid = fromCh.videos[index];
  const title = vid?.title ? escHtml(vid.title) : 'este vídeo';
  hint.innerHTML = `Origen: <strong>CH ${escHtml(String(fromCh.num))}</strong> · ${escHtml(fromCh.name || '')}<br>Selecciona destino para <strong>${title}</strong>:`;

  list.innerHTML = '';
  let any = false;
  catalog.forEach((ch, i) => {
    if (i === selectedChannel || isTopVotedChannel(ch)) return;
    any = true;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-secondary';
    btn.style.cssText = 'width:100%;text-align:left;font-size:13px;padding:10px 14px;display:flex;align-items:center;gap:10px';
    btn.innerHTML = `<span style="color:${ch.color || '#fff'};font-family:'Share Tech Mono',monospace;font-size:12px">CH ${escHtml(String(ch.num))}</span><span style="flex:1">${escHtml(ch.name || '')}</span>`;
    btn.onclick = () => void executeMoveVideoToChannel(i);
    list.appendChild(btn);
  });

  if (!any) {
    list.innerHTML = '<div style="color:rgba(255,255,255,0.35);font-size:13px;padding:8px">No hay otros canales disponibles.</div>';
  }

  modal.classList.remove('hidden');
}

export function closeMoveVideoToChannelModal() {
  _moveVideoIndex = null;
  document.getElementById('move-video-channel-modal')?.classList.add('hidden');
}

export async function executeMoveVideoToChannel(targetChannelIndex) {
  if (_moveVideoIndex === null) return;
  if (!currentUser?.is_admin) {
    showToast('Solo administradores', true);
    return;
  }

  const pos = _moveVideoIndex;
  const fromCh = catalog[selectedChannel];
  const toCh = catalog[targetChannelIndex];

  if (!fromCh?.id || !toCh?.id || pos < 0 || pos >= fromCh.videos.length) {
    closeMoveVideoToChannelModal();
    return;
  }
  if (isTopVotedChannel(fromCh) || isTopVotedChannel(toCh)) {
    showToast('No se puede usar canal Top voted como origen o destino', true);
    closeMoveVideoToChannelModal();
    return;
  }

  try {
    const res = await fetch(`/channels/${fromCh.id}/move-video`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ position: pos, to_channel_id: toCh.id }),
    });
    if (!res.ok) throw new Error(await res.text());

    const movedVideo = fromCh.videos.splice(pos, 1)[0];
    toCh.videos.push(movedVideo);
    closeMoveVideoToChannelModal();
    renderVideoList();
    showToast(`Movido a CH ${toCh.num} · ${toCh.name}`);
  } catch (e) {
    console.error(e);
    showToast('ERROR AL MOVER VÍDEO', true);
  }
}

/** Click en el backdrop cierra el modal */
export function initMoveVideoChannelModalBackdrop() {
  const modal = document.getElementById('move-video-channel-modal');
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeMoveVideoToChannelModal();
    });
  }
}